export default __webpack_public_path__ + "static/media/download.99dbce67.svg";